module.exports = __webpack_public_path__ + "img/guide-min.5471a5af.png";